import React, { useEffect } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { FormDropdown, getById, mapToDropdownOption } from "sprint-common-web";

import { handleOptionChange } from "../../../../common/utils/handleOptionChange";
import { useOrderAirlines } from "../common/hooks/useOrderAirlines";
import { useCreateOrder } from "../common/provider/useCreateOrder";

interface OrderAirlinesSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
    previouslySubmitted: boolean;
    trigger(name?: string | string[] | undefined): Promise<boolean>;
    clearErrors(name?: string | string[] | undefined): void;
}

export const OrderAirlinesSelector: React.FC<OrderAirlinesSelectorProps> = ({
    label,
    name,
    control,
    errors,
    previouslySubmitted,
    trigger,
    clearErrors
}: OrderAirlinesSelectorProps) => {
    const { airline, setAirline } = useCreateOrder();

    const { data: airlines } = useOrderAirlines();

    useEffect(() => {
        if (airline) {
            control.setValue(name, airline.id);
            clearErrors(name);
        } else {
            control.setValue(name, "");

            if (previouslySubmitted) {
                trigger(name);
            }
        }
    }, [airline]);

    const handleAirlineSelected = (value: string) => {
        const selectedAirline = airlines && getById(airlines, value);

        setAirline(selectedAirline);
    };

    const handleAirlineUnselected = () => {
        setAirline(undefined);
    };

    return (
        <FormDropdown
            label={label}
            placeholder="Search and select airline"
            name={name}
            options={airlines?.map((item) => mapToDropdownOption(item)) ?? []}
            control={control}
            errors={errors}
            rules={{ required: "Select airline" }}
            onChange={handleOptionChange(handleAirlineSelected, handleAirlineUnselected)}
        />
    );
};
